export default __webpack_public_path__ + "static/media/Background_00219.e2e0fca7.png";